import DateCell from "./DateCell";
// import UnassignedShifts from "./UnassignedShifts";
import DailyInfo from "./DailyInfo";
import { useScheduleContext } from "../../../../hooks/context/useScheduleContext";
import { useScrollContext } from "../../../../hooks/context/useScrollContext";
import { useGridDates } from "../../../../hooks/grid/useGridDates";
import { cn } from "../../../../../../../lib/utils";

interface ContentProps {
    cellWidth: number;
    currentTimeOffset: any;
}

function Content({ cellWidth, currentTimeOffset, }: ContentProps) {
    const { gridDates } = useGridDates();
    const {
        setHeaderContainerRef,
        scrollbarWidth,
        handlePaneWheel,
        headerContentRef,
        dailyInfoRef
    } = useScrollContext();
    const { dailyInfo } = useScheduleContext();

    return (
        <div
            ref={setHeaderContainerRef}
            className="header-container"
            style={{ paddingRight: `${scrollbarWidth}px` }}
            onWheel={handlePaneWheel}
        >
            <div ref={headerContentRef} className="tw-h-full tw-flex tw-flex-col">
                <div className={cn("header-content-inner", !dailyInfo && "tw-flex-1")}>
                    {gridDates.map((day: string, index: number) => (
                        <DateCell
                            key={`${day}-duplicate`}
                            day={day}
                            cellIndex={index}
                            currentTimeOffset={currentTimeOffset}
                            cellWidth={cellWidth}
                        />
                    ))}
                </div>

                {dailyInfo /**&& loadindDailyInfo */ && (
                    <div className="header-content-inner tw-flex-1" ref={dailyInfoRef}>
                        <DailyInfo cellWidth={cellWidth} currentTimeOffset={currentTimeOffset} />
                    </div>
                )}

                {/* {!(loading || loadingUnassignedEvents) && (
                    <>
                        <UnassignedShifts
                            cellWidth={cellWidth}
                            currentTimeOffset={currentTimeOffset}
                        />
                    </>
                )} */}
            </div>
        </div>
    );
}

export default Content;
